import { defineComponent as _defineComponent } from 'vue';
import SaveCancelButtons from '../../../Components/SaveCancelButtons.vue';
import useVuelidate from '@vuelidate/core';
import { required, decimal, minValue } from '@vuelidate/validators';
import { reactive, ref } from 'vue';
import { useRoute } from '../../../Plugins/ziggy';
import { useSpinner } from '../../../Plugins/spinner';
import { useAxios } from '../../../Plugins/axios';
import { useMitt } from '../../../Plugins/mitt';
import { DateTime } from 'luxon';
import { trans } from 'laravel-vue-i18n';
import InputNumber from '../../../Components/InputNumber.vue';
import DocumentsForm from '../../../Components/DocumentsForm.vue';
import { processDataForm } from '../../../Services/Utils';
import RecordBasicInfo from '../RecordBasicInfo.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditCreate',
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    emits: ['update:modelValue', 'cancel', 'saved'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const route = useRoute();
        const spinner = useSpinner();
        const axios = useAxios();
        const emitter = useMitt();
        const documentsForm = ref();
        const newDocuments = ref([]);
        const defaultDate = (props.data.date
            ? DateTime.fromISO(props.data.date, { zone: 'utc' })
            : DateTime.now()).toJSDate();
        const data = reactive({
            id: props.data.id,
            orchard_id: props.data.orchard?.id,
            plot_ids: [],
            description: props.data.description || '',
            date: defaultDate,
            nitrogen: props.data.nitrogen,
            phosphorus: props.data.phosphorus,
            potassium: props.data.potassium,
            calcium: props.data.calcium,
            magnesium: props.data.magnesium,
            sulfur: props.data.sulfur,
            sodium: props.data.sodium,
            boron: props.data.boron,
            iron: props.data.iron,
            manganese: props.data.manganese,
            copper: props.data.copper,
            zinc: props.data.zinc,
            green_index: props.data.green_index,
        });
        const rules = {
            orchard_id: { required },
            plot_ids: { required },
            description: { required },
            date: { required },
            nitrogen: { decimal, minValue: minValue(0) },
            phosphorus: { decimal, minValue: minValue(0) },
            potassium: { decimal, minValue: minValue(0) },
            calcium: { decimal, minValue: minValue(0) },
            magnesium: { decimal, minValue: minValue(0) },
            sulfur: { decimal, minValue: minValue(0) },
            sodium: { decimal, minValue: minValue(0) },
            boron: { decimal, minValue: minValue(0) },
            iron: { decimal, minValue: minValue(0) },
            manganese: { decimal, minValue: minValue(0) },
            copper: { decimal, minValue: minValue(0) },
            zinc: { decimal, minValue: minValue(0) },
            green_index: { decimal, minValue: minValue(0) },
        };
        const v$ = useVuelidate(rules, data);
        const numericFields = [
            [
                {
                    field: 'nitrogen',
                    unit: '%',
                },
                {
                    field: 'phosphorus',
                    unit: '%',
                },
                {
                    field: 'potassium',
                    unit: '%',
                },
                {
                    field: 'calcium',
                    unit: '%',
                },
                {
                    field: 'magnesium',
                    unit: '%',
                },
            ],
            [
                {
                    field: 'sulfur',
                    unit: '%',
                },
                {
                    field: 'sodium',
                    unit: '%',
                },
                {
                    field: 'boron',
                    unit: 'mg/kg',
                },
                {
                    field: 'iron',
                    unit: 'mg/kg',
                },
            ],
            [
                {
                    field: 'manganese',
                    unit: 'mg/kg',
                },
                {
                    field: 'copper',
                    unit: 'mg/kg',
                },
                {
                    field: 'zinc',
                    unit: 'mg/kg',
                },
                {
                    field: 'green_index',
                    unit: '',
                },
            ],
        ];
        const save = async () => {
            const valid = await v$.value.$validate();
            if (!valid) {
                return;
            }
            documentsForm.value.upload();
            const formData = processDataForm(data, newDocuments.value, props.data.documents);
            let url = data.id
                ? route('api.leaves-data.update', [data.id])
                : route('api.leaves-data.store');
            spinner.show();
            axios
                .post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((res) => {
                emit('saved', res.data.data);
                emitter.emit('leaves-data-saved', res.data.data);
            })
                .catch((err) => {
                console.log(err);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { route, spinner, axios, emitter, props, emit, documentsForm, newDocuments, defaultDate, data, rules, v$, numericFields, save, SaveCancelButtons, get trans() { return trans; }, InputNumber, DocumentsForm, RecordBasicInfo };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
